<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions">
        <a-form class="flex-form form-label-5" :form="form">
          <div class="grid grid-cols-4 2xl:grid-cols-5">
            <a-form-item label="订单号码" prop="orderNo">
              <a-input class="form-control" v-decorator="['orderNo']" placeholder="请输入订单号" allowClear></a-input>
            </a-form-item>
            <a-form-item label="产品名称" prop="productName">
              <a-input
                class="form-control"
                v-decorator="['productName']"
                placeholder="请输入订单号"
                allowClear
              ></a-input>
            </a-form-item>
            <a-form-item label="申请人" prop="customerName">
              <a-input
                v-decorator="['customerName']"
                placeholder="请输入姓名"
                allowClear
                class="form-control"
              ></a-input>
            </a-form-item>
            <div></div>
            <div style="flex: 1;display: flex;justify-content: flex-end;">
              <a-button class="app-btn" type="default" @click="resetAndQuery">重置搜索</a-button>
              <a-button class="app-btn" style="margin-left: 10px;" type="primary" @click="doQuery(1)">立即搜索</a-button>
            </div>
          </div>
        </a-form>
      </div>
    </template>
    <div>
      <div class="pageContent-title">订单列表</div>
      <!-- <div class="queryView-actions">
        <a-button class="app-btn" @click="doExport">
          <app-icon type="icon-daochu"></app-icon>
          导出EXCEL
        </a-button>
      </div> -->
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="
            (record, index) => {
              return index
            }
          "
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :expandIconColumnIndex="-1"
          :expandIconAsCell="false"
          :expandedRowKeys.sync="expandedRowKeys"
          :scroll="{ x: 2500 }"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: total => {
              return `共${Math.ceil(total / pageSize)}页/${total}条数据 `
            },
          }"
        ></a-table>
      </div>
      <a-modal v-model="modalVisible" :title="modalTitle" :width="800" centered @ok="handelOk" @cancel="handleCancel">
        <div>
          <a-form class="flex-form" :form="remarkForm">
            <a-form-item label="订单备注" prop="orderNo">
              <a-input
                class="form-control"
                type="textarea"
                :rows="4"
                v-decorator="['adminRemark']"
                placeholder="请输入备注"
                style="width: 100%"
                allowClear
              ></a-input>
            </a-form-item>
          </a-form>
        </div>
      </a-modal>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import { sex, orderChannel, transferOrderSubStatus } from '@/vars'
import fileDownload from 'js-file-download'

export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '订单号',
        align: 'center',
        dataIndex: 'orderNo',
      },
      {
        title: '创建时间',
        align: 'center',
        dataIndex: 'createTime',
      },
      {
        title: '所属供应商',
        align: 'center',
        dataIndex: 'supplierName',
      },
      {
        title: '产品名称',
        align: 'center',
        dataIndex: 'productName',
      },
      {
        title: '订单金额',
        align: 'center',
        dataIndex: 'paymentAmount',
      },
      {
        title: '产品单价',
        align: 'center',
        dataIndex: 'productPrice',
      },
      {
        title: '订单成本价',
        align: 'center',
        dataIndex: 'orderCost',
      },
      {
        title: '服务费',
        align: 'center',
        dataIndex: 'serviceAmount',
      },
      {
        title: '手续费',
        align: 'center',
        dataIndex: 'paymentFee',
      },
      {
        title: '姓名（人数）',
        width: '10%',
        align: 'center',
        dataIndex: '',
        customRender: row => {
          return (
            <div>
              {row.applicantName}({row.applicantCount})
            </div>
          )
        },
      },
      {
        title: '操作人',
        align: 'center',
        dataIndex: 'operatorName',
      },
      {
        title: '备注',
        align: 'center',
        dataIndex: 'costPrice',
        customRender: (text, row) => {
          return (
            <div
              class="flex gap-5 justify-center text-primary-500 relative"
              style="cursor: pointer;"
              onClick={e => {
                this.checkRemark(row)
              }}
            >
              {row.adminRemark ? row.adminRemark : '添加备注'}
            </div>
          )
        },
      },
      {
        title: '操作',
        width: '8%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex gap-5 justify-center text-primary-500 relative">
              <span
                onClick={e => {
                  this.checkRow(row)
                }}
              >
                查看
              </span>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      remarkForm: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
      rowKey: 'id',
      modalVisible: false,
      modalTitle: '订单备注',
      expandedRowKeys: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {
        sex: sex,
        orderChannel: orderChannel,
        status: [
          { value: 3, label: '已支付' },
          { value: 4, label: '待接单' },
          { value: 5, label: '审核中' },
          { value: 6, label: '审核失败' },
          { value: 7, label: '审核成功' },
          { value: 8, label: '待邮寄' },
          { value: 9, label: '已邮寄' },
          { value: 10, label: '操作中' },
          { value: 11, label: '需补寄资料' },
          { value: 12, label: '已出签' },
          { value: 13, label: '已收货' },
          { value: 14, label: '订单有误' },
          { value: 15, label: '申请退款' },
          { value: 16, label: '退款中' },
          { value: 17, label: '已退款' },
          { value: 18, label: '资料已补充' },
        ],
        subStatus: transferOrderSubStatus,
      }
    },
  },
  async mounted() {
    this.doQuery()
  },
  methods: {
    handelOk() {
      // TODO 添加备注
      this.modalVisible = false
    },
    checkRemark(row) {
      this.remarkForm.setFieldsValue({
        orderNo: row.orderNo,
        adminRemark: row.adminRemark,
      })
      this.modalVisible = true
      this.modalTitle = '订单备注'
    },
    handleCancel() {
      this.modalVisible = false
    },
    handleOk() {
      this.remarkForm.validateFields(async (err, values) => {
        if (!err) {
          try {
            await this.$axios.post(`/visa/admin/order/${orderNo}/remark`, {
              params: {
                remark: values.adminRemark,
              },
            })
            this.$message.success('操作成功!')
            this.modalVisible = false
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    resetAndQuery() {
      this.resetAndQuery$qv()
    },
    getParams() {
      const params = this.form.getFieldsValue()
      return {
        ...params,
      }
    },
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.get('/visa/admin/order', {
          params: {
            page: _pageNumber,
            limit: _pageSize,
            ...this.getParams(),
          },
        })
        this.countTotal = Number(res.count)
        this.dataSource = res.data
        this.expandedRowKeys = []
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    checkRow(row) {
      this.$router.push({
        path: '/m/scopeMain/transferOrder/transferOrderList',
        query: {
          orderNo: row.orderNo,
        },
      })
    },
    checkExpress(text) {
      console.log('sf??', text)
      this.$refs.ExpressInfo.start(text)
    },
    removeRow() {},
    isExpanded(row) {
      return this.expandedRowKeys.includes(row[this.rowKey])
    },
    async changeRowExpand(row) {
      const isExpanded = this.isExpanded(row)
      let expandedRowKeys = [...this.expandedRowKeys]
      // 先展开行，显示loading
      if (!isExpanded) {
        expandedRowKeys.push(row[this.rowKey])
      } else {
        expandedRowKeys = expandedRowKeys.filter(key => key !== row[this.rowKey])
      }
      this.expandedRowKeys = expandedRowKeys
      // 再获取数据
      if (!isExpanded) {
        this.$set(row, 'subList', undefined)
        try {
          const res = await this.$axios.get('/visa/admin/order/orderTransferVisa/getDetailList', {
            params: {
              orderId: row.orderId,
            },
          })
          this.$set(row, 'subList', res.data ?? [])
        } catch (e) {
          console.log(e)
        }
      }
    },
    async doExport() {
      const res = await this.$axios.post(
        `/visa/admin/order/orderTransferVisa/getMainListDownload`,
        {
          ...this.getParams(),
        },
        {
          responseType: 'blob',
          interceptors: {
            response: false,
          },
        }
      )
      fileDownload(res.data, '转单订单.xls')
    },
  },
}
</script>

<style lang="less" scoped>
.order-table {
  margin: -16px;
  background: #f4f4f4;
  .order-table-row {
    display: grid;
    grid-template-columns: 20% 15% 5% 10% 10% 10% 10% 10% 10%;
  }
  .order-table-head {
    position: relative;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      background-color: transparent;
    }
    font-weight: bold;
  }
  .order-table-col {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px 5px;
    border-bottom: 1px solid #dfdfdf;
  }
  .order-table-body {
    .order-table-col {
      padding: 5px;
    }
  }
  .order-table-head {
    font-weight: bold;
  }
}
</style>
